module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.963805f9.ttf";